import ContactArea from "@/components/publicWebsite/contact/contactArea";
import CoursesArea from "@/components/publicWebsite/courses/coursesArea";
import PageHeader from "@/components/publicWebsite/common/pageHeader";
import { coursesData } from "@/db/coursesData"; 


export default function Courses() { 
  return (
    <>
      <PageHeader title="Courses" image="/images/banners/c18.png" />
      <div className="pb-120 border-bottom"></div>
      <CoursesArea
        titleShown={false}
        data={coursesData}
        className="border-top-0 border-bottom-0"
      />
      <ContactArea />
    </>
  );
};
 